/**
 * Session cache behind the hub's summary-card counts, so switching views does not refetch
 * them. Mappings and value sets are tenant-wide (one entry each); entity counts are keyed by
 * ATS system. Pages that change what is counted call invalidateHubCounts(), which drops the
 * cache and tells every mounted hub to refetch.
 */
const countCache = new Map<string, Promise<number>>()
const listeners = new Set<() => void>()

export function cachedCount(key: string, load: () => Promise<number>): Promise<number> {
  let pending = countCache.get(key)
  if (!pending) {
    pending = load().catch((err) => {
      countCache.delete(key)
      throw err
    })
    countCache.set(key, pending)
  }
  return pending
}

/** Runs `refresh` whenever the counts are invalidated; returns the unsubscribe */
export function onHubCountsInvalidated(refresh: () => void): () => void {
  listeners.add(refresh)
  return () => {
    listeners.delete(refresh)
  }
}

export function invalidateHubCounts(): void {
  countCache.clear()
  listeners.forEach((notify) => notify())
}
